import { defineMessage } from 'react-intl';
import { useCheapestRateDisplayInformation } from './use-cheapest-rate-display-information';
import { emptyObject } from 'ui-components/default-props/empty';
import { useEnableCheapestRate } from '../../../../feature-flags/hooks/use-enable-cheapest-rate';
import { GROUP_IDS } from '../../constants';
import { useFulfillmentPlannerContext } from '../../../../fulfillment-planner/context';

const name = defineMessage({
  description: 'best way to ship group name',
  defaultMessage: 'Recommended (Least Cost)',
  id: 'rZ1ITS',
});

export const useBestWayToShipGroup = (selectedItem) => {
  const { bestWayToShip } = useFulfillmentPlannerContext();
  const isCheapestRateEnabled = useEnableCheapestRate();

  const { disabled, displayText } = useCheapestRateDisplayInformation(bestWayToShip);
  const selectedServiceId = selectedItem?.serviceId;
  if (!isCheapestRateEnabled) {
    return null;
  }
  const { cheapestOption } = bestWayToShip || emptyObject;
  const { shippingServiceId, sellerProviderId } = cheapestOption || emptyObject;
  const bestWayToShipGroup = {
    groupId: GROUP_IDS.BEST_WAY_TO_SHIP,
    name,
    items: [
      {
        serviceId: shippingServiceId !== undefined ? `${shippingServiceId}` : undefined,
        name: displayText,
        disabled,
        selected: shippingServiceId !== undefined && `${shippingServiceId}` === `${selectedServiceId}`,
        sellerLabelProviderId: `${sellerProviderId}`,
      },
    ],
  };

  return bestWayToShipGroup;
};
